import { REHYDRATE } from 'redux-persist/constants'
import { HANDLE_USER_SESSION, PASSWORD_RESET, FORGOT_PASSWORD_CODE_SENT, REGISTERING, AUTH_ERROR, SIGN_OUT, NEW_PASSWORD_REQUIRED, SIGNING_IN, HANDLE_NEW_CREDENTIALS, NEW_USER_ATTRIBUTES, ACCEPT_TOS } from '../actions/auth';
import { SYNC_AUTH_ERROR } from '../actions/sync';

const auth = (state = {token: null}, action) => {
  switch(action.type) {
    case HANDLE_NEW_CREDENTIALS:
      var groups = JSON.parse(atob(action.token.split('.')[1]))['cognito:groups'] || [];
      return {
        ...state,
        fetching: false,
        token: action.token,
        isAdmin: groups.length && !!groups.find((g) => g === 'admins'),
        error: null,
      }
    case HANDLE_USER_SESSION:
      var groups = JSON.parse(atob(action.token.split('.')[1]))['cognito:groups'] || [];
      return {
        ...state,
        fetching: false,
        token: action.token,
        error: null,
        name: action.name,
        email: action.email,
        organization: action.organization,
        isAdmin: groups.length && !!groups.find((g) => g === 'admins'),
        tos: action.tos
      }
    case SIGN_OUT:
      return {
        ...state,
        error: null,
        name: null,
        email: null,
        organization: null,
        token: null,
        fetching: false,
        tos: false
      }
    case REHYDRATE:
      if (action.payload && action.payload.auth) {
        return {
          ...action.payload.auth,
          newPasswordRequired: false,
          fetching: false,
          error: null,
          forgotPasswordCodeSent: false
        }
      } else {
        return state;
      }
    case SIGNING_IN:
      return {
        ...state,
        fetching: true,
        error: null
      }
    case REGISTERING:
      return {
        ...state,
        error: null,
        fetching: true
      }
    case SYNC_AUTH_ERROR:
    case AUTH_ERROR:
      return {
        ...state,
        error: action.error,
        fetching: false,
        name: null,
        email: null,
        organization: null,
        token: null,
        tos: false
      }
    case NEW_PASSWORD_REQUIRED:
      return {
        ...state,
        fetching: false,
        newPasswordRequired: true,
        error: null
      }
    case NEW_USER_ATTRIBUTES:
      return {
        ...state,
        userAttributes: action.attributes,
        error: null
      }
    case FORGOT_PASSWORD_CODE_SENT:
      return {
        ...state,
        error: null,
        fetching: false,
        forgotPasswordCodeSent: true
      }
    case PASSWORD_RESET:
      return {
        ...state,
        error: null,
        forgotPasswordCodeSent: false,
        fetching: false
      }
    case ACCEPT_TOS:
      return {
        ...state,
        tos: 'signed'
      }
    default:
      return state;
  }
}

export default auth;

export const isSignedIn = (state) => !!state.email
